import React, { useEffect } from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { IStoreState } from "../../Store";
import { TicketInfoPanelV1 } from "../../TicketInfoPanel/TicketInfoPanelV1";
import { SeatInfo } from "../../TicketInfoPanel/SeatInfoV1";
import { loadTicketSharingData } from "./actions";
import { addToken } from "../../../commons/utils/addToken";
import { ThunkDispatch } from "redux-thunk";
import {
  IOwnerTicketInfo,
  IRemoteData,
  ShareStatus,
  IAuth,
  IEnvironment
} from "../../../interface/IShareInfo";
import { SharePanel } from "../../SharePanel";
import { useParams, useLocation, RouteComponentProps } from "react-router-dom";
import { ErrorBar } from "../../Ui/ErrorBar";
import { showLoading } from "../../Ui/ConnectedFullscreenLoader/actions";

const useStyles = makeStyles(({ palette }) => {
  return createStyles({
    root: {
      marginBottom: 10
    }
  });
});

export interface IPropsTicketSharing extends RouteComponentProps {
  showLoading: (loadingText?: string) => void;
  loadData: (ticketGroupId: string, ticketId?: string) => void;
  ticketSharingData: IRemoteData<IOwnerTicketInfo>;
  authData: IRemoteData<IAuth>;
  env: IEnvironment;
}

export const TicketSharingComponent = ({
  loadData,
  ticketSharingData: { loading, data, error },
  authData,
  showLoading,
  env
}: IPropsTicketSharing) => {
  const classes = useStyles({});

  const { ticketGroupId, ticketId } = useParams() as any;
  const location = useLocation();

  useEffect(() => {
    if (ticketGroupId) {
      loadData(ticketGroupId as string, ticketId as string);
    }
  }, []);

  useEffect(() => {
    if (error) {
      window.scroll(0, 0);
    }
  }, [error]);

  const renderPanel = () => {
    if (!data || !data.shareStatus || !data.ticketGroupId || !data.ticketId) {
      return null;
    }

    if (
      [
        ShareStatus.Accepted,
        ShareStatus.Requested,
        ShareStatus.ErrorStatus
      ].includes(data.shareStatus)
    ) {
      let mobiUrl = "";
      const mobiUrlStartIndex = location.search.indexOf("mobiUrl=");

      if (location.search && mobiUrlStartIndex > -1) {
        mobiUrl = location.search.slice(
          location.search.indexOf("mobiUrl=") + "mobiUrl=".length
        );
        // add token
        if (authData.data && authData.data.token) {
          mobiUrl = addToken(mobiUrl, authData.data.token);
        }
      }

      // redirect to ticketek.mobil
      if (mobiUrl) {
        showLoading("Back to your ticket...");
        window.location.href = mobiUrl as string;
      } else {
        showLoading("Error ticket...");
        window.location.href = env.HOMEPAGE_URL;
      }

      return null;
    }

    return <SharePanel />;
  };

  return (
    <div className={classes.root}>
      {error && <ErrorBar message={error.message} />}
      <TicketInfoPanelV1 venueInfo={data && data.venueInfo} loading={loading}>
        {<SeatInfo loading={loading} seatInfo={data && data.seatInfo} />}
      </TicketInfoPanelV1>
      {renderPanel()}
    </div>
  );
};

const mapStateToProps = (state: IStoreState) => {
  return {
    ticketSharingData: state.ticketShareData,
    authData: state.authData,
    env: state.env
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
  return {
    loadData: (ticketGroupId: string, ticketId: string) =>
      dispatch(loadTicketSharingData(ticketGroupId, ticketId)),
    showLoading: (loadingText?: string) => dispatch(showLoading(loadingText))
  };
};

export const TicketSharing = connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketSharingComponent);
